<template>
  <div class="relative min-h-screen h-full">
    <header :class="[$style['header']]">
      <img
        v-if="$route.params.site === 'v4b'"
        src="@/assets/images/v4b_header.png"
        class="w-full hidden md:block"
      >
      <img
        v-if="$route.params.site === 'v4b'"
        src="@/assets/images/v4b_header_mobile.jpg"
        class="w-full block md:hidden"
      >

      <img
        v-if="$route.params.site === 'golf8jarama'"
        src="@/assets/images/signup_header.jpg"
        class="w-full hidden md:block"
      >
      <img
        v-if="$route.params.site === 'golf8jarama'"
        src="@/assets/images/signup_header_mobile.jpg"
        class="w-full block md:hidden"
      >

      <img
        v-if="$route.params.site === 'id-experience-barcelona' || $route.params.site === 'id-experience-madrid'"
        src="@/assets/images/experience_header.jpg"
        class="w-full hidden md:block"
      >
      <img
        v-if="$route.params.site === 'id-experience-barcelona' || $route.params.site === 'id-experience-madrid'"
        src="@/assets/images/experience_header_mobile.jpg"
        class="w-full block md:hidden"
      >

      <div
        :class="$style['content']"
        class="mt-3 text-sm font-bold"
      >
        <router-link
          :to="{ name: 'apuntate' }"
          class="link"
        >
          Volver
        </router-link>
      </div>
    </header>

    <section
      :class="$style['content']"
      class="mt-10"
    >
      <template v-if="waitingList">
        <h3 class="font-light text-l sm:text-xl sm:leading-xl md:text-2xl md:leading-2xl lg:text-xxl leading-l lg:leading-xxl">
          {{ textConfirmationWaitingList }}
        </h3>

        <p class="text-base leading-xs md:text-m lg:leading-m mb-6 mt-4 md:mt-6 font-light">
          Cuando tengamos una plaza libre nos pondremos en contacto contigo.
        </p>
      </template>

      <template v-else>
        <h3 class="font-light text-l sm:text-xl sm:leading-xl md:text-2xl md:leading-2xl lg:text-xxl leading-l lg:leading-xxl">
          {{ textConfirmation }}
        </h3>

        <p class="text-base leading-xs md:text-m lg:leading-m mb-6 mt-4 md:mt-6 font-light">
          {{ textPrivilege }}
        </p>
      </template>
    </section>
  </div>
</template>

<script>

export default {
  props: {
    waitingList: {
      type: Boolean,
      default: false
    }
  },

  mounted () {
    this.$emit('update-menu-color', '#001e50')
  },

  computed: {
    textConfirmation () {
      if (this.$route.params.site === 'v4b') {
        return 'Bienvenid@, ya tienes tu plaza confirmada.'
      }

      if (this.$route.params.site === 'golf8jarama') {
        return 'Bienvenid@, ya tienes tu plaza confirmada para ver la presentación del nuevo Golf 8 en el Circuito del Jarama.'
      }

      if (this.$route.params.site === 'id-experience-barcelona') {
        return 'Bienvenid@, ya tienes tu plaza confirmada para ver la presentación del nuevo ID Experience en Barcelona.'
      }

      if (this.$route.params.site === 'id-experience-madrid') {
        return 'Bienvenid@, ya tienes tu plaza confirmada para ver la presentación del nuevo ID Experience en Madrid.'
      }

      return ''
    },

    textConfirmationWaitingList () {
      if (this.$route.params.site === 'v4b') {
        return '¡Gracias. Te has apuntado en la lista de espera.'
      }

      if (this.$route.params.site === 'golf8jarama') {
        return '¡Bienvenid@, te has apuntado en la lista de espera de la presentación del nuevo Golf 8.'
      }

      if (this.$route.params.site === 'id-experience-barcelona') {
        return '¡Bienvenid@, te has apuntado en la lista de espera de la presentación del nuevo ID Experience.'
      }

      if (this.$route.params.site === 'id-experience-madrid') {
        return '¡Bienvenid@, te has apuntado en la lista de espera de la presentación del nuevo ID Experience.'
      }

      return ''
    },

    textPrivilege () {
      if (this.$route.params.site === 'v4b') {
        return 'Eres uno de los privilegiados en ver, tocar y descubrir la tecnología del ID.Buzz'
      }

      if (this.$route.params.site === 'golf8jarama') {
        return 'Eres uno de los privilegiados en ver, tocar y descubrir la tecnología del nuevo Golf 8 por primera vez en España.'
      }

      if (this.$route.params.site === 'id-experience-barcelona') {
        return 'Eres uno de los privilegiados en ver, tocar y descubrir la tecnología del nuevo ID Experience por primera vez en España.'
      }

      if (this.$route.params.site === 'id-experience-madrid') {
        return 'Eres uno de los privilegiados en ver, tocar y descubrir la tecnología del nuevo ID Experience por primera vez en España.'
      }

      return ''
    }
  }
}
</script>

<style
  module
  lang="scss"
>
.content {
  @apply m-auto;

  padding: 0 20px;
  max-width: 1064px;
}

.header {
  margin-top: 168px;
}
</style>
